import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const AcceptTermsLabelWrapper = styled.div``

export const PasswordChecksWrapper = styled.div`
  margin-top: -${Spacing.S8};
`
